/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import { message } from 'element-ui';
/** 
 * 提示函数 
 */
const tip = msg => message(msg)

/** 
 * 请求失败后的错误统一处理 
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        case -1:
            // tip(other);
            break;
            // 404请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        case 500:
            tip('服务器错误');
            break;
        case 10000:
            tip('网络繁忙');
            break;
        case 10003:
            tip('添加失败');
            break;
        case 10004:
            tip('更新失败');
            break;
        case 10005:
            tip(other);
            break;
        default:
            // tip(other);
    }
}

// 创建axios实例
let http = axios.create({
    timeout: 1000 * 10,
    xhrFields: {
        withCredentials: false
    },
    withCredentials: true,
    crossDomain: true,
    emulateJSON: true
});
// 设置post请求头
http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
/** 
 * 请求拦截器 
 * 每次请求前，如果存在token则在请求头中携带token 
 */
http.interceptors.request.use(
    config => {
        // const token = getToken();
        // config.headers["user_token"] = token
        return config;
    },
    error => Promise.reject(error)
)

// 响应拦截器
http.interceptors.response.use(
    // 请求成功
    res => {
        if (res.status === 200 && res.data.code === 0) {
            return Promise.resolve(res.data);
        } else {
            errorHandle(res.data.code, res.data.msg);
            return Promise.reject(res.data);
        }

    },
    // 请求失败
    error => {
        const {
            response
        } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围 
            errorHandle(response.status, response.data.message);
        }
        return Promise.reject(response)
    });
export default http;